<ngx-loading-bar color="#fff"></ngx-loading-bar>
<div class="fabber-container">
    <app-header [inApp]="inSketchup || inFusion360" *ngIf="!noHeader"></app-header>
    <app-alert></app-alert>
    <div [ngClass]="{'fabber-noscroll': noScroll, 'fabber-scroll': !noScroll}">
        <router-outlet></router-outlet>
    </div>
</div>
<!--<app-tasks></app-tasks>-->
